import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './index.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AP from './pages/AP';
import AC from './pages/AC';
import CPC from './pages/CPC';
import RUSD from './pages/RUSD';
import CGU from './pages/CGU';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import DeclarationAccessibilite from './pages/DeclarationAccessibilite';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/nos-ap" element={<AP />} />
        <Route path="/nos-ac" element={<AC />} />
        <Route path="/nos-cpc" element={<CPC />} />
        <Route path="/nos-rusd" element={<RUSD />} />
        <Route path="/conditions-generales-d-utilisation" element={<CGU />} />
        <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/declaration-daccessibilite" element={<DeclarationAccessibilite />} />
      </Routes>
      <Footer/>
    </Router>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();